module.exports = __webpack_public_path__ + "static/columbia-362c6ccf45a3982f2060aa2cf53624f2.jpg";